<template>
  <div class="content-box job-share-list">
    <h2 v-if="hasTitle" class="text-center mb-8">
      <strong>{{ title }}</strong>
    </h2>

    <ul class="job-share-list__items">
      <share-item
        v-for="(_, index) in shareSettings"
        :key="`share_icon_${index}`"
        v-model="shareSettings[index]"
        :hasCustomSocialMediaIcons="hasCustomSocialMediaIcons"
        :slug="slug"
        class="job-share-list__item"
      />
    </ul>
  </div>
</template>

<script>
import { mapState } from 'vuex';
import shareItem from './job-share-item.vue';

export default {
  props: {
    data: {
      type: Object,
      required: true
    },

    maxColumns: {
      type: Number,
      required: false,
      default: 4
    }
  },

  computed: {
    ...mapState('jobsModule', {
      jobDetails: 'currentJobDetails'
    }),

    ...mapState('companyModule', {
      hasCustomSocialMediaIcons: 'hasCustomSocialMediaIcons',
      slug: 'slug'
    }),

    shareSettings() {
      return this.jobDetails.shareSettings;
    },

    hasTitle() {
      return (
        this.data.title &&
        Object.keys(this.data.title).length > 0 &&
        this.localize(this.data.title)
      );
    },

    title() {
      if (Array.isArray(this.data.title)) {
        return this.localize(this.data.title);
      } else {
        return this.localize(this.data.title[0]);
      }
    }
  },

  components: {
    shareItem
  }
};
</script>
